var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{attrs:{"tag":"div","dense":"","color":"transparent","elevation":"0","align-with-title":"","light":""}},[_c('v-breadcrumbs',{staticClass:"crumbs py-3 px-0",attrs:{"items":_vm.filteredBreadcrumbs}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }